import Backbone from 'backbone';

module.exports = Backbone.Model.extend({
  defaults: {
    maxHeight: 300,
    top: 75,
    height: 100,
    width: 200,
    open: true,
    bgcolor: 'rgba(0,0,0,.6)'
  },

  initialize(o = {}) {}
});
